export default __webpack_public_path__ + "static/media/large.fcf5db97.jpg";